import { css } from 'styled-components';
import { COLORS } from '../../../config/theme';

const style = () => css`
    .user-insights-toolbar {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        margin-bottom: 16px;
        flex-wrap: wrap;

        .user-insights-title {
            color: ${(props) => props.theme[COLORS.PRIMARY_TEXT]};
            font-size: 24px;
            font-weight: 700;
        }

        .ant-picker-range {
            border-radius: 5px;
        }

        .user-insights-range-select {
            width: 180px;
            max-width: 100%;
        }
    }

    .user-insights-meta {
        display: flex;
        gap: 10px;
        flex-wrap: wrap;
        margin-bottom: 16px;
    }

    .user-insights-meta-item,
    .user-insights-summary-card {
        background: ${(props) => props.theme[COLORS.WHITE]};
        border-radius: 5px;
        box-shadow: ${(props) => props.theme[COLORS.CARD_SHADOW]};
    }

    .user-insights-meta-item {
        padding: 10px 12px;
        min-width: 190px;
    }

    .user-insights-meta-label,
    .user-insights-summary-label {
        color: ${(props) => props.theme[COLORS.ICONS]};
        font-size: 12px;
        font-weight: 600;
        text-transform: uppercase;
    }

    .user-insights-meta-value {
        color: ${(props) => props.theme[COLORS.PRIMARY_TEXT]};
        font-size: 13px;
        font-weight: 700;
        margin-top: 4px;
    }

    .user-insights-summary-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(185px, 1fr));
        gap: 12px;
        margin-bottom: 16px;
    }

    .user-insights-summary-card {
        padding: 16px;
        min-width: 0;
    }

    .user-insights-summary-value {
        color: ${(props) => props.theme[COLORS.PRIMARY_TEXT]};
        font-size: 28px;
        font-weight: 800;
        line-height: 1;
        margin-top: 8px;
    }

    .user-insights-chart-section {
        min-width: 0;
        padding: 16px;
    }

    .user-insights-chart-section {
        background: ${(props) => props.theme[COLORS.WHITE]};
        margin-bottom: 16px;
    }

    .user-insights-root-chart {
        overflow-x: auto;
    }

    .user-insights-card-title {
        color: ${(props) => props.theme[COLORS.PRIMARY_TEXT]};
        font-size: 18px;
        font-weight: 700;
        margin: 0 0 12px;
    }

    .user-insights-loading,
    .user-insights-empty {
        min-height: 320px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .user-insights-error {
        margin-bottom: 16px;
    }

    @media (max-width: 768px) {
        .user-insights-toolbar {
            align-items: flex-start;
            flex-direction: column;
        }

        .user-insights-toolbar .ant-picker,
        .user-insights-toolbar .user-insights-range-select {
            width: 100%;
        }
    }
`;

export default style();
